import { render, staticRenderFns } from "./AppReadMore.global.vue?vue&type=template&id=70384259&"
import script from "./AppReadMore.global.vue?vue&type=script&lang=js&"
export * from "./AppReadMore.global.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports